<template>
  <v-card rounded="xl" flat class="mutabakat-blocked-card">
    <div class="d-flex flex-column align-center text-center pa-8">
      <v-avatar color="error" size="64" class="mb-4">
        <v-icon color="white" size="32">{{ icons.mdiFileDocumentAlertOutline }}</v-icon>
      </v-avatar>
      <div class="text-h6 font-weight-bold mb-2">Mutabakat Onayınız Bekleniyor</div>
      <div class="text-body-2 text--secondary" style="max-width: 420px">
        Mutabakat onaylama süreniz dolduğu için ürünleri görüntüleyemez ve
        sipariş veremezsiniz. Lütfen "Mutabakat Onay Geçmişim" sayfasından
        onaylayın veya reddedin.
      </div>
    </div>
  </v-card>
</template>

<script>
import { mdiFileDocumentAlertOutline } from "@mdi/js";

export default {
  name: "MutabakatOrderBlockedAlert",
  setup() {
    return {
      icons: {
        mdiFileDocumentAlertOutline,
      },
    };
  },
};
</script>

<style scoped>
.mutabakat-blocked-card {
  background-color: var(--v-grey-base, rgba(255, 255, 255, 0.05));
  max-width: 640px;
  margin: 24px auto;
}
</style>
